<!-- shopy Head -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
  </div>
</div>
<div class="collecting-header" style="background-image: url(assets/image/Group-1895.png);">
  <div class="collecting-head">
    <div class="head">
      <h3>{{category}} Documents</h3>
    </div>
  </div>
</div>

<!-- <h1 class="head">Choose the category</h1> -->
<!-- <p>{{data.category}}<br><br><br><br><br><br></p> -->
<!-- collections details -->
<div class="container">
  <div class="collection-items">
    <div class="row">
      <ng-template ngFor let-item [ngForOf]="displayItems">
    

        <div class="col-lg-4 col-md-6 collections"  >
          <div class="collection-elements">
            <!-- <div class="coll-image">
              <img src="assets/image/Resources-and-Research-APS-tmp.png">
            </div> -->
            <div class="coll-detials">
              <h2>{{item.searchname}}</h2>
              <!-- <p class="text"></p> -->
            </div>
            <div class="coll-btn-item">
              <a (click) =downlaodUrl(item.searchname,item.url)
              class="btn btn-primary" style="background-color: #d5b256;border-color: #d5b256;">Download</a>
            </div>
           
            <!-- <div class="coll-btn-item">
              <a href='{{item.ereader_url}}' target="_blank" class="coll-btn">View/Read</a>
            </div> -->
            <!-- <div class="date-cmds">
                          <div class="row">
                              <div class="col-12 text-left">
                                  <i class="fa fa-calendar" aria-hidden="true"></i> {{item.art_date}}
                              </div>
                              
                          </div>
                      </div> -->
          </div>
        </div>
      </ng-template>

    </div>
    <!-- pagination -->
    <!-- <ul class="pagination">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="onPageChange(currentPage - 1)">Previous</a>
      </li>
      <li class="page-item" *ngFor="let page of getPaginationArray()" [class.active]="currentPage === page">
        <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
        <a class="page-link" (click)="onPageChange(currentPage + 1)">Next</a>
      </li>
    </ul> -->
    <ul class="pagination">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="onPageChange(currentPage - 1)">Previous</a>
      </li>
      <!-- <li class="page-item" *ngFor="let page of getPaginationArray()" [class.active]="currentPage === page">
        <a class="page-link" (click)="onPageChange(page)">
          <ng-container *ngIf="page !== '...'">{{ page }}</ng-container>
          <ng-container *ngIf="page === '...'">&hellip;</ng-container>
        </a>
      </li> -->
      <li class="page-item" *ngFor="let page of getPaginationArray()" [class.active]="currentPage === page">
  <a class="page-link" (click)="onPageChange(page)">
    <ng-container *ngIf="page !== '...'">{{ page }}</ng-container>
    <ng-container *ngIf="page === '...'">&hellip;</ng-container>
  </a>
</li>

      <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
        <a class="page-link" (click)="onPageChange(currentPage + 1)">Next</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === getTotalPages()">
        <a class="page-link" (click)="onLastPage()" *ngIf="showLastPage">Last Page</a>
      </li>
    </ul>
  </div>
<!-- </div> -->
 <!-- Pagination -->


</div>

<app-contactform></app-contactform>